import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import Field from '@/packages/field';
import DictApi from '@/api/dict';
import { InfoComplementField } from '../../types';

import style from './index.module.scss';

@Component({ name: 'PreTaxMonthSalary' })
export default class PreTaxMonthSalary
  extends Vue
  implements InfoComplementField {
  @Prop()
  private value!: undefined | number;

  private preTaxMonthSalary: undefined | number | null = null;

  private errorMsg = '';

  private created() {
    if (this.value) {
      this.preTaxMonthSalary = this.value;
    }
  }

  @Watch('value')
  private onValueChange(val: undefined | number) {
    if (val !== this.preTaxMonthSalary) {
      this.preTaxMonthSalary = val;
    }
  }

  public onValidator(): boolean {
    if (this.preTaxMonthSalary === undefined || this.preTaxMonthSalary === null) {
      this.errorMsg = '请选择月薪';
      return false;
    }

    return true;
  }

  private onChangePreTaxMonthSalary(val: number | undefined | null) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private render() {
    return (
      <div class={style.PreTaxMonthSalary}>
        <Field
          v-model={this.preTaxMonthSalary}
          label="月薪"
          sub={true}
          type="select"
          onChange={() => this.onChangePreTaxMonthSalary(this.preTaxMonthSalary)}
          dictApi={DictApi.getIncomeType}
          error={this.errorMsg}
          readonly={true}
        />
      </div>
    );
  }
}
